import groq from 'groq'

const slugField = (locale: string) => (locale === 'en' ? 'slugEn' : 'slugFr')

export const postsQuery = (locale: string) => groq`
  *[_type == "post" && defined(${slugField(locale)}.current)] | order(publishedAt desc) {
    "title": title.${locale},
    "slug": ${slugField(locale)}.current,
    "excerpt": excerpt.${locale},
    publishedAt,
    updatedAt,
    author->{name, photo},
    "categories": categories[]->{"title": title.${locale}, "slug": slug.current}
  }`

export const categoriesQuery = (locale: string) => groq`
  *[_type == "category" && defined(slug.current)] | order(title.fr asc) {
    "title": title.${locale},
    "slug": slug.current
  }`

export const postQuery = (locale: string) => groq`
  *[_type == "post" && ${slugField(locale)}.current == $slug][0] {
    "title": title.${locale},
    "excerpt": excerpt.${locale},
    "body": body.${locale},
    "keyTakeaways": keyTakeaways.${locale},
    publishedAt,
    _updatedAt,
    author->{ name, photo, "role": role.${locale}, "bio": bio.${locale}, linkedin },
    categories[]->{"title": title.${locale}, "slug": slug.current},
    "sources": sources[]{ "label": label.${locale}, url, publisher },
    "faq": faq[]{ "question": question.${locale}, "answer": answer.${locale} },
    "seoTitle": seo.title.${locale},
    "seoDescription": seo.description.${locale},
    "ogImage": seo.ogImage,
    "otherSlug": ${locale === 'en' ? 'slugFr' : 'slugEn'}.current,
    "relatedPosts": relatedPosts[defined(@->_id) && @->${slugField(locale)}.current != $slug]->{
      "title": title.${locale},
      "slug": ${slugField(locale)}.current,
      "excerpt": excerpt.${locale},
      publishedAt,
      updatedAt,
      author->{name}
    },
    "previousPost": *[_type == "post" && defined(${slugField(locale)}.current) && publishedAt < ^.publishedAt] | order(publishedAt desc)[0]{
      "title": title.${locale},
      "slug": ${slugField(locale)}.current
    },
    "nextPost": *[_type == "post" && defined(${slugField(locale)}.current) && publishedAt > ^.publishedAt] | order(publishedAt asc)[0]{
      "title": title.${locale},
      "slug": ${slugField(locale)}.current
    }
  }`

// ponytail: fallback "Articles associés" = 6 most recent OTHER posts when the
// editor curated none. Curated relatedPosts (up to 6, from postQuery) win.
export const relatedPostsQuery = (locale: string) => groq`
  *[_type == "post" && defined(${slugField(locale)}.current) && ${slugField(locale)}.current != $slug]
    | order(publishedAt desc)[0...6] {
    "title": title.${locale},
    "slug": ${slugField(locale)}.current,
    "excerpt": excerpt.${locale},
    publishedAt,
    updatedAt,
    author->{name}
  }`

export const legalQuery = (locale: string) => groq`
  *[_type == "legalPage" && ${slugField(locale)}.current == $slug][0] {
    "title": title.${locale},
    "body": body.${locale},
    updatedAt,
    "otherSlug": ${locale === 'en' ? 'slugFr' : 'slugEn'}.current
  }`

export const sitemapQuery = groq`{
  "posts": *[_type == "post"]{ "fr": slugFr.current, "en": slugEn.current, "updated": publishedAt }
}`
